module.exports = __webpack_public_path__ + "img/small-17.93f677d2.webp";